(() => {
  if (window.xcCollectionInitialized) return;
  window.xcCollectionInitialized = true;
  const pending = new WeakMap();
  const timers = new WeakMap();
  const scope = '[data-xc-collection-section]';
  function formURL(form) {
    const url = new URL(form.action, location.origin);
    const params = new URLSearchParams(new FormData(form));
    [...params.entries()].forEach(([key,value]) => { if (!value.trim() || key === 'page' || key === 'section_id') params.delete(key); });
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) params.set('preview_theme_id',preview);
    url.search = params.toString();
    return url;
  }
  function normalizeURL(root, href) {
    const url = new URL(href, location.href);
    if (url.origin !== location.origin) return null;
    const view = root.dataset.xcView;
    if (view && !url.searchParams.has('view')) url.searchParams.set('view', view);
    if (!url.searchParams.has('sort_by')) {
      const value = root.querySelector('[data-xc-collection-sort]')?.value;
      if (value) url.searchParams.set('sort_by', value);
    }
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id',preview);
    url.searchParams.delete('section_id');
    return url;
  }
  function density(root, count) {
    if (!['2','4','6'].includes(String(count))) count = '4';
    root.dataset.xcColumns = count;
    root.querySelectorAll('[data-xc-density]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.xcDensity === String(count))));
  }
  function searchBrands(directory) {
    const field = directory.querySelector('[data-xc-brand-search]');
    const normalized = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'');
    const query = normalized(field?.value || '').trim();
    const links = [...directory.querySelectorAll('[data-xc-sidebar-brand]')];
    let visible = 0;
    links.forEach(link => { const match = normalized(link.dataset.brandName || link.textContent).includes(query); link.hidden = !match; if (match) visible++; });
    const empty = directory.querySelector('.xc-brand-list-empty');
    if (empty) empty.hidden = visible !== 0;
    const count = directory.querySelector('[data-xc-brand-count]');
    if (count) count.textContent = query ? `${visible} of ${links.length} brands` : `${links.length} brands`;
  }
  function initialize(root) {
    let count = root.dataset.xcColumns || '4';
    try { count = sessionStorage.getItem('xc-collection-density') || count; } catch (_) {}
    density(root,count);
    root.querySelectorAll('[data-xc-brand-directory]').forEach(searchBrands);
  }
  function closeFilters(root) {
    root.querySelector('.xc-collection-filter-dialog[open]')?.close();
  }
  async function refresh(root, url, focusId, historyMode = true, scroll = false) {
    if (!url || url.origin !== location.origin) return;
    const previous = pending.get(root);
    previous?.controller.abort();
    const controller = new AbortController();
    const state = {controller};
    pending.set(root,state);
    const results = root.querySelector('[data-xc-collection-results]');
    results.setAttribute('aria-busy','true');
    const status = results.querySelector('.xc-collection-loading');
    if (status) status.hidden = false;
    const request = new URL(url);
    request.searchParams.set('section_id',root.dataset.xcCollectionSection);
    const timeout = setTimeout(() => controller.abort('timeout'),15000);
    try {
      const response = await fetch(request,{signal:controller.signal,headers:{'X-Requested-With':'XMLHttpRequest'}});
      if (!response.ok) throw new Error('Collection refresh failed');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const next = doc.querySelector('[data-xc-collection-results]');
      if (!next) throw new Error('Missing collection results');
      if (pending.get(root) !== state) return;
      closeFilters(root);
      // Dawn moves opened modals to body. Remove only this section's old targets before replacing cards.
      const prefix = 'XCQuickShop-' + root.dataset.xcCollectionSection + '-';
      document.querySelectorAll('quick-add-modal').forEach(modal => { if (modal.id.startsWith(prefix) && !results.contains(modal)) modal.remove(); });
      results.innerHTML = next.innerHTML;
      results.removeAttribute('aria-busy');
      initialize(root);
      if (historyMode) history.pushState({xcCollection:true},'',url.pathname + url.search);
      if (focusId) root.querySelector('#' + CSS.escape(focusId))?.focus({preventScroll:true});
      if (scroll) root.querySelector('.xc-collection-heading')?.scrollIntoView({behavior:'auto',block:'start'});
      else if (!focusId) root.querySelector('.xc-open-collection-filters')?.focus({preventScroll:true});
    } catch (error) {
      if (pending.get(root) !== state) return;
      // Native Shopify navigation remains the fallback; no false empty-results message.
      location.assign(url.pathname + url.search);
    } finally {
      clearTimeout(timeout);
      if (pending.get(root) === state) pending.delete(root);
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-xc-collection-form]');
    if (!form) return;
    event.preventDefault();
    const root = form.closest(scope);
    clearTimeout(timers.get(root));
    refresh(root,formURL(form));
  });
  document.addEventListener('input',event => { if (event.target.matches('[data-xc-brand-search]')) searchBrands(event.target.closest('[data-xc-brand-directory]')); });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-xc-brand-search]')) return;
    const root = event.target.closest(scope);
    if (!root) return;
    const sort = event.target.matches('[data-xc-collection-sort]');
    const form = sort ? event.target.form : event.target.closest('[data-xc-collection-form="desktop"]');
    if (!form) return;
    clearTimeout(timers.get(root));
    timers.set(root,setTimeout(() => refresh(root,formURL(form),event.target.id),sort ? 0 : 200));
  });
  document.addEventListener('click', event => {
    const root = event.target.closest(scope);
    if (!root) return;
    const grid = event.target.closest('[data-xc-density]');
    if (grid) {
      density(root,grid.dataset.xcDensity);
      try { sessionStorage.setItem('xc-collection-density',grid.dataset.xcDensity); } catch (_) {}
      return;
    }
    const open = event.target.closest('.xc-open-collection-filters');
    if (open) {
      const dialog = root.querySelector('.xc-collection-filter-dialog');
      const previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      open.setAttribute('aria-expanded','true');
      document.documentElement.style.overflow = 'hidden';
      dialog.addEventListener('close',() => { document.documentElement.style.overflow = previousOverflow; open.setAttribute('aria-expanded','false'); if (open.isConnected) open.focus({preventScroll:true}); },{once:true});
      return;
    }
    if (event.target.closest('.xc-close-collection-filters')) { closeFilters(root); return; }
    const dialog = event.target.closest('.xc-collection-filter-dialog');
    if (dialog && event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      return;
    }
    const link = event.target.closest('[data-xc-filter-link],.pagination-wrapper a');
    if (link && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const url = normalizeURL(root,link.href);
      if (url) { event.preventDefault(); refresh(root,url,null,true,link.closest('.pagination-wrapper') !== null); }
    }
  });
  document.addEventListener('keydown',event => {
    if (event.key === 'Enter' && event.target.matches('[data-xc-brand-search]')) { event.preventDefault(); return; }
    if (event.key !== 'Escape') return;
    const dialog = document.querySelector('.xc-collection-filter-dialog[open]');
    if (dialog) { event.preventDefault(); dialog.close(); }
  });
  window.addEventListener('popstate',() => { const root = document.querySelector(scope); if (root) refresh(root,new URL(location.href),null,false); });
  window.addEventListener('resize',() => { if (innerWidth > 900) document.querySelectorAll('.xc-collection-filter-dialog[open]').forEach(dialog => dialog.close()); });
  document.addEventListener('shopify:section:load',event => { event.target.querySelectorAll(scope).forEach(initialize); });
  document.addEventListener('shopify:section:unload',event => { event.target.querySelectorAll(scope).forEach(root => { closeFilters(root); pending.get(root)?.controller.abort(); pending.delete(root); clearTimeout(timers.get(root)); }); });
  document.querySelectorAll(scope).forEach(initialize);
})();
